import { render } from "./TimeboxedFlow.vue?vue&type=template&id=390d990a"
import script from "./TimeboxedFlow.vue?vue&type=script&lang=js"
export * from "./TimeboxedFlow.vue?vue&type=script&lang=js"

import "./TimeboxedFlow.vue?vue&type=style&index=0&id=390d990a&lang=scss"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__